import { render } from "./PurchaseTableHead.vue?vue&type=template&id=4e2fac0e"
import script from "./PurchaseTableHead.vue?vue&type=script&lang=js"
export * from "./PurchaseTableHead.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__